import { Injectable } from "@angular/core";
import { ProductsService } from "./products.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { loadDangerousGoodsCodes, loadDangerousGoodsCodesFailure, loadDangerousGoodsCodesSuccess, loadProductCategories, loadProductCategoriesFailure, loadProductCategoriesSuccess } from "./products.actions";
import { switchMap, map, catchError, of } from "rxjs";

@Injectable()
export class ProductsEffects {
    constructor(private actions$: Actions, private productsService: ProductsService) { }

    loadProductCategories$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadProductCategories),
            switchMap((action) =>
                this.productsService.getProductCategories(action.freightpayerId).pipe(
                    map((productCategories) => loadProductCategoriesSuccess({ categories: productCategories })),
                    catchError((error) => of(loadProductCategoriesFailure({ error: error.message })))
                )
            )
        )
    );

    loadDangerousGoodsCodes$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadDangerousGoodsCodes),
            switchMap(() =>
                this.productsService.getDangerousGoodsCodes().pipe(
                    map((dangerousGoodsCodes) => loadDangerousGoodsCodesSuccess({ dangerousGoodsCodes })),
                    catchError((error) => of(loadDangerousGoodsCodesFailure({ error: error.message })))
                )
            )
        )
    );
}